import { useTranslation } from "react-i18next";
import { Switch } from "src/@/components/ui/switch";
import Iconify from "src/components/Iconify";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from "src/@/components/ui/tooltip";

export default function SwitchInfoTooltip({
  checked,
  onCheckedChange,
  label,
  info
}) {
  const { t } = useTranslation("automation");
  // Textos padrão do tooltip, mas podem ser sobrescritos por props!
  const resolvedLabel = label ?? t("execution.onlyOnceLabel", "Executar 1 vez (recomendado)");
  const resolvedInfo =
    info ??
    t(
      "execution.onlyOnceDefaultInfo",
      "Se o chat tem chances de receber a mesma automação mais de uma vez, mantenha este campo desmarcado."
    );

  return (
    <div className="flex items-center gap-2 mt-4 ">
        <div className="flex items-center gap-2">
        <Switch
        checked={checked}
        onCheckedChange={onCheckedChange}
      />
      <label className="text-sm font-medium">{resolvedLabel}</label>
        </div>

      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span tabIndex={0} className="flex items-center">
              <Iconify icon="mdi:information-outline" width={18} className="text-slate-500 cursor-pointer" />
            </span>
          </TooltipTrigger>
          <TooltipContent side="top" align="center" className="w-[270px]">
            {resolvedInfo}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}